import React from 'react';
import { includes } from 'lodash';
import { ButtonGroup, Button } from 'ui';
import { routes } from 'constants/config';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { updateItem } from 'utils/fp';
import request from 'utils/request_ajax';
import LinkButton from 'components/shared/LinkButton';
import ScrollableContainer from 'components/shared/scrollable';
import Drawer from './DrawerContainer';
import DrawerGroup from './DrawerGroup';
import RelatedUrlLabel from '../shared/RelatedUrlLabel';
import ContentLibraryLabel from '../shared/ContentLibraryLabel';

class DisplayPermissions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
      roles: this.props.roles,
    };
  }

  getPermissions() {
    this.props.roles.forEach(role => {
      request.get(routes.ROLE_PERMISSIONS(role.id)).then(({ permissions }) => {
        this.setState(state => ({
          roles: updateItem(state.roles, { id: role.id }, { permissions }),
        }));
      });
    });
  }

  toggleModal() {
    if (!this.state.shown) {
      this.getPermissions();
    }

    this.setState(prevState => ({ shown: !prevState.shown }));
  }

  render() {
    const { hasChromeExtension, hasWebWidget } = this.props.features;

    return (
      <>
        <LinkButton className="fz-base fw-n" onClick={() => this.toggleModal()}>
          {t('users.role.help_text')}
        </LinkButton>
        {this.state.shown && (
          <RenderInBody>
            <ModalContainer
              className="ModalTakeover-background Modal-background d-f ai-c"
              onEscape={() => this.toggleModal()}
            >
              <div className="ModalTakeover-container bg-gray-lightest w-fill">
                <div className="ModalTakeover-main d-f fd-c ">
                  <div className="ModalTakeover-title">
                    {t('roles.permission_modal.title')}
                  </div>
                  <ScrollableContainer
                    className="ScrollableContainer--bordered pr-0"
                    maxHeight="440"
                  >
                    <DrawerGroup>
                      {this.state.roles.map(role => (
                        <Drawer key={role.id}>
                          <Drawer.Title>{role.name}</Drawer.Title>
                          <Drawer.Content>
                            <ul>
                              <li>
                                {t(
                                  'roles.permission_modal.can_receive_assignments',
                                )}
                              </li>
                              {role.permissions && (
                                <>
                                  {includes(
                                    role.permissions,
                                    'create_content',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.create_content',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'create_edit_roles',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.create_edit_roles',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'create_edit_tags',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.create_edit_tags',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'create_edit_triggers',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.create_edit_triggers',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'create_events',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.create_events',
                                      )}
                                    </li>
                                  )}
                                  {includes(role.permissions, 'edit_all') && (
                                    <>
                                      <li>
                                        {t(
                                          'roles.permission_modal.edit_all.manage_all_people',
                                        )}
                                      </li>
                                      <li>
                                        {t(
                                          'roles.permission_modal.edit_all.create_and_edit_people',
                                        )}
                                      </li>
                                    </>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'edit_all_events',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.edit_all_events',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'edit_groups',
                                  ) && (
                                    <li>
                                      {t('roles.permission_modal.edit_groups')}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'instruct_events',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.instruct_events',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'manage_groups',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.manage_groups',
                                      )}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'manage_content_library',
                                  ) && (
                                    <li>
                                      <ContentLibraryLabel
                                        {...this.props.features}
                                      />
                                    </li>
                                  )}
                                  {includes(role.permissions, 'own_all') && (
                                    <li>
                                      {t('roles.permission_modal.own_all')}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'own_content',
                                  ) && (
                                    <li>
                                      {t('roles.permission_modal.own_content')}
                                    </li>
                                  )}
                                  {includes(
                                    role.permissions,
                                    'manage_company_settings',
                                  ) && (
                                    <li>
                                      {t(
                                        'roles.permission_modal.manage_company_settings',
                                      )}
                                    </li>
                                  )}
                                  {(hasChromeExtension || hasWebWidget) &&
                                    includes(
                                      role.permissions,
                                      'chrome_extension_mappings',
                                    ) && (
                                      <li>
                                        <RelatedUrlLabel
                                          {...this.props.features}
                                        />
                                      </li>
                                    )}
                                </>
                              )}
                            </ul>
                          </Drawer.Content>
                        </Drawer>
                      ))}
                    </DrawerGroup>
                  </ScrollableContainer>
                  <ButtonGroup alignEnd>
                    <Button
                      className="mt-24"
                      onClick={() => this.toggleModal()}
                    >
                      Dismiss
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </ModalContainer>
          </RenderInBody>
        )}
      </>
    );
  }
}

export default DisplayPermissions;
